import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@izimi/auth';
import {
  Link,
  Navigation,
  NavigationUserMenuHeader,
  NotificationsPopOver,
} from '@izimi/components';
import { getUserRole } from '@izimi/modules';
import { ApiRole } from 'api';

import IzimiLogo from './IzimiLogo';
import { ShareDocument } from './ShareDocument';
import { Routes } from './types';
import useNavigationMenu from './useNavigationMenu';

const Nav = () => {
  const { mainMenu, userMenu, helpMenu } = useNavigationMenu();
  const { user } = useAuth();
  const { t } = useTranslation();

  const userName = user ? `${user.profile.firstName} ${user.profile.lastName}` : '';

  const renderUserMenuHeader = useMemo(() => {
    if (!user) {
      return null;
    }
    const role = getUserRole(user.profile.roles);

    const rolesLabels: Record<ApiRole, string> = {
      [ApiRole.Notary]: t('roles.notary'),
      [ApiRole.Citizen]: t('roles.citizen'),
      [ApiRole.Collaborator]: t('roles.collaborator'),
    };

    const label = role ? rolesLabels[role] : '';
    const notaryInfo = user ? `${label} · ${user.profile.studyName}` : '';

    return <NavigationUserMenuHeader title={userName} subTitle={notaryInfo} />;
  }, [user, t, userName]);

  return (
    <Navigation<Routes>
      renderLogo={(onClick) => (
        <Link to={Routes.Vault} onClick={onClick}>
          <IzimiLogo />
        </Link>
      )}
      renderQuickActions={<ShareDocument />}
      mainMenu={mainMenu}
      helpMenu={helpMenu}
      userMenu={userMenu}
      userName={userName}
      renderUserMenuHeader={renderUserMenuHeader}>
      <NotificationsPopOver<typeof Routes> routes={Routes} />
    </Navigation>
  );
};

export default Nav;
